export const TRACKING_UPDATE = 'TRACKING_UPDATE'

export function update(payload) {
	return {
		type: TRACKING_UPDATE,
		payload
	}
}
